import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useTw } from '../../../../../utils/Styles'
import { getHighestStatus } from '../../../../../utils'
import { StatusPageEventHistoryItemComponentStatus } from '../../../../../api/types'
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
} from '@heroicons/react/outline'
import { useStatusPageQuery } from './StatusPage.generated'

export function Status() {
  const tw = useTw()
  const navigate = useNavigate()
  const [t] = useTranslation('common')
  const { data } = useStatusPageQuery()
  const components = data?.Profile?.statusPage?.components

  const statusPageNavigate = () => navigate('/status-page')

  const issues = useMemo(
    () =>
      (components || [])
        ?.map((_) => _.eventsHistory[0].events)
        .flat()
        .filter((_) => _.ongoing)
        .map((_) => _?.historyItems?.[0].affectedComponents ?? [])
        .flat()
        .map((_) => _.componentStatus),
    [components]
  )

  switch (getHighestStatus(issues)) {
    case StatusPageEventHistoryItemComponentStatus.Degraded:
      return (
        <div
          onClick={statusPageNavigate}
          className={tw`cursor-pointer flex pt-1 items-center justify-center space-x-1`}
        >
          <ExclamationCircleIcon className={tw`h-5 w-5 text-yellow-600`} />
          <span className={tw`text-sm text-gray-800`}>
            {t('status_page.home_statuses.issues')}
          </span>
        </div>
      )

    case StatusPageEventHistoryItemComponentStatus.PartialOutage:
    case StatusPageEventHistoryItemComponentStatus.MajorOutage:
      return (
        <div
          onClick={statusPageNavigate}
          className={tw`cursor-pointer flex pt-1 items-center justify-center space-x-1`}
        >
          <ExclamationCircleIcon className={tw`h-5 w-5 text-red-600`} />
          <span className={tw`text-sm text-gray-800`}>
            {t('status_page.home_statuses.issues')}
          </span>
        </div>
      )

    default:
      return (
        <div
          onClick={statusPageNavigate}
          className={tw`cursor-pointer flex pt-1 items-center justify-center space-x-1`}
        >
          <CheckCircleIcon className={tw`h-5 w-5 text-green-600`} />
          <span className={tw`text-sm text-gray-800`}>
            {t('status_page.home_statuses.operational')}
          </span>
        </div>
      )
  }
}
